/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Custom_EnterInputs */



/**
* | output |
* | --- |
* | "Enter manually" |
*
* @param {Spaces_Modular_Wizard_Custom_EnterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_custom_enter = /** @type {((inputs?: Spaces_Modular_Wizard_Custom_EnterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Custom_EnterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuell eingeben")
	return /** @type {LocalizedString} */ ("Enter manually")
});